module.exports = __webpack_public_path__ + "static/media/cat.870dcf42.png";